// src/components/ComingSoon.tsx

import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
// 1. İkonu Dumbbell olarak değiştiriyoruz.
import { ArrowLeft, Dumbbell } from "lucide-react";

interface ComingSoonProps {
  pageTitle: string;
  message?: string;
}

export function ComingSoon({
  pageTitle,
  message = "Bu bölüm şu anda yapım aşamasındadır. Yeni özellikleri ve içerikleri size sunmak için sabırsızlanıyoruz.",
}: ComingSoonProps) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background pt-20">
      <div className="container flex flex-col items-center justify-center space-y-6 px-4 text-center">
        {/* 2. Rocket yerine Dumbbell ikonunu kullanıyoruz. */}
        <Dumbbell className="h-16 w-16 text-primary" />
        <div className="space-y-2">
          <h1 className="font-extrabold text-4xl text-foreground tracking-tighter sm:text-5xl md:text-6xl">
            {pageTitle}: Çok Yakında!
          </h1>
          <p className="mx-auto max-w-[700px] text-muted-foreground md:text-xl">
            {message}
          </p>
        </div>
        <Button asChild>
          <Link to="/">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Ana Sayfaya Dön
          </Link>
        </Button>
      </div>
    </div>
  );
}
